import { useLang } from "hooks/useLang"
import React from "react"
import ReactMarkdown from "react-markdown"

interface IProps {
    content: string
    title?: string
}

const markdownComponents = () => {
    const { lang } = useLang()

    return {
        ol: ({ ...props }) => (
            <ol {...props} className={`list-decimal  text-sm font-light`} />
        ),
        ul: ({ ...props }) => (
            <ul
                {...props}
                className={`list-disc  ${lang == "ar" ? "list-inside pr-6" : "pl-6"} text-sm font-light list-decimal `}
            />
        ),
        li: ({ ...props }) => (
            <li {...props} className="mb-2 text-sm font-light" />
        ),
        h1: ({ ...props }) => (
            <h1
                {...props}
                className="mb-1 mt-5 font-semibold text-xl md:text-2xl first:mt-0"
            />
        ),
        h2: ({ ...props }) => (
            <h2
                {...props}
                className="mb-1 mt-5 font-semibold text-lg md:text-xl first:mt-0"
            />
        ),
        h3: ({ ...props }) => (
            <h3
                {...props}
                className="mb-1 mt-5 font-semibold text-md md:text-lg first:mt-0"
            />
        ),
        h4: ({ ...props }) => (
            <h4
                {...props}
                className="mb-1 mt-5 font-semibold text-sm md:text-md first:mt-0"
            />
        ),
        p: ({ ...props }) => (
            <p {...props} className="mb-2 text-sm lg:text-md font-light" />
        ),
    }
}

const CustomMarkdown = ({ content, title }: IProps) => {
    return (
        <div>
            {title && <h2 className="text-md font-semibold mb-4">{title}</h2>}
            <ReactMarkdown components={markdownComponents()}>
                {content}
            </ReactMarkdown>
        </div>
    )
}

export default CustomMarkdown
